import { ErrorHandler, Injectable } from '@angular/core'
import { SopimusPalvelupaketti } from '@lemon/core-firebase/model/kayttaja'
import { TuettuKieli } from '@lemon/core/model/common'
import { LemonTranslationService } from '../service/lemon-translation.service'

@Injectable()
export class PalvelukokonaisuusService {
  constructor(
    private _translationService: LemonTranslationService,
    private _errorHandler: ErrorHandler,
  ) {}

  public annaPalvelukokonaisuus(palvelupaketti: SopimusPalvelupaketti, kieli: TuettuKieli): string[] {
    if (palvelupaketti === SopimusPalvelupaketti.TMI_MAKSUPERUSTEINEN) {
      return [
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.henkilokohtainen-kirjanpitaja', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.maksuperusteinen-kirjanpito', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.aloituspalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.arvonlisaveroilmoitukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.elinkeinotoiminnan-veroilmoitus', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.lemonaid-ohjelmisto', kieli),
      ]
    }
    if (palvelupaketti === SopimusPalvelupaketti.TMI_LASKUPERUSTEINEN) {
      return [
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.henkilokohtainen-kirjanpitaja', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.laskuperusteinen-kirjanpito', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.aloituspalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.arvonlisaveroilmoitukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.elinkeinotoiminnan-veroilmoitus', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.lemonaid-ohjelmisto', kieli),
      ]
    }
    if (palvelupaketti === SopimusPalvelupaketti.OY_MAKSUPERUSTEINEN || palvelupaketti === SopimusPalvelupaketti.OY_KAPITALISAATIOSOPIMUS) {
      return [
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.henkilokohtainen-kirjanpitaja', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.maksuperusteinen-kirjanpito', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.aloituspalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.arvonlisaveroilmoitukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatos', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatoksen-rekisterointi', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.elinkeinotoiminnan-veroilmoitus', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.huojennetun-osingon-laskenta', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.lemonaid-ohjelmisto', kieli),
      ]
    }
    if (palvelupaketti === SopimusPalvelupaketti.OY_LASKUPERUSTEINEN) {
      return [
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.henkilokohtainen-kirjanpitaja', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.laskuperusteinen-kirjanpito', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.aloituspalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.arvonlisaveroilmoitukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatos', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatoksen-rekisterointi', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.elinkeinotoiminnan-veroilmoitus', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.huojennetun-osingon-laskenta', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.lemonaid-ohjelmisto', kieli),
      ]
    }
    if (palvelupaketti === SopimusPalvelupaketti.KASVU_SUORITEPERUSTEINEN) {
      return [
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.henkilokohtainen-kirjanpitaja', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.suoriteperusteinen-kirjanpito', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.kuukausittaiset-jaksotukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.ennakkoverojen-seuranta', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.aloituspalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.arvonlisaveroilmoitukset', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatospalaveri', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.tilinpaatoksen-rekisterointi', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.elinkeinotoiminnan-veroilmoitus', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.huojennetun-osingon-laskenta', kieli),
        this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.lemonaid-ohjelmisto', kieli),
      ]
    }
    if (palvelupaketti === SopimusPalvelupaketti.VAIN_PALKAT) {
      return []
    }
    if (palvelupaketti === SopimusPalvelupaketti.HOLVI_ZEN) {
      return []
    }
    if (palvelupaketti === SopimusPalvelupaketti.MUU) {
      return []
    }

    return []
  }

  annaPalvelupaketinNimi(paketti: SopimusPalvelupaketti, kieli: TuettuKieli) {
    if (paketti === SopimusPalvelupaketti.TMI_MAKSUPERUSTEINEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.toiminimi-maksuperusteinen', kieli)
    }
    if (paketti === SopimusPalvelupaketti.TMI_LASKUPERUSTEINEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.toiminimi-laskuperusteinen', kieli)
    }
    if (paketti === SopimusPalvelupaketti.OY_MAKSUPERUSTEINEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.osakeyhtio-maksuperusteinen', kieli)
    }
    if (paketti === SopimusPalvelupaketti.OY_LASKUPERUSTEINEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.osakeyhtio-laskuperusteinen', kieli)
    }
    if (paketti === SopimusPalvelupaketti.OY_KAPITALISAATIOSOPIMUS) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.osakeyhtio-kapitalisaatiosopimus', kieli)
    }
    if (paketti === SopimusPalvelupaketti.KASVU_SUORITEPERUSTEINEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.kasvu', kieli)
    }
    if (paketti === SopimusPalvelupaketti.VAIN_PALKAT) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.palkat', kieli)
    }
    if (paketti === SopimusPalvelupaketti.HOLVI_ZEN) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.holvi-zen', kieli)
    }
    if (paketti === SopimusPalvelupaketti.MUU) {
      return this._translationService.lokalisoiKielella('lemonaid-sopimus-dialog.muu', kieli)
    }
    this._errorHandler.handleError(new Error('Tuntematon palvelupaketti: ' + paketti + '!'))
    return kieli === 'en' ? 'No service package' : 'Ei palvelupakettia'
  }
}
